import React, { useState } from "react";
import styles from "../../Application.module.scss";
import HeadingWithLine from "../../../../components/HeadingWithLine/HeadingWithLine";
import ButtonIcon from "../../../../components/ButtonIcon/ButtonIcon";
import useCommonStore from "../../../../stores/common";
import { dateFormatter, formatPhoneNumber, formatNumberWithSpaces, maskNumber } from "../../../../../components/helper/helper";

function PersonalInformation({ appData }) {
  const expandAppDetails = useCommonStore((state) => state.expandDetails);
  const [expended, setExpended] = useState(false);

  const toggleExpend = () => {
    setExpended(!expended);
  };

  const getIdType = (type) => {
    if (type == "PASSPORT") return "Passport";
    if (type == "STATE_ID") return "Driver's License";
    if (type == "LOCAL_STATE_ID") return "State ID";
    if (type == "CITIZENSHIP_CARD") return "Citizenship Card";
    return "-";
  }

  return (
    <div
      className={`${styles.personal_information} ${expandAppDetails ? styles.expanded : ""}`}
    >
      <div className={styles.head}>
        <ButtonIcon onClick={toggleExpend}>
          <svg
            className={expended ? styles.expended : ""}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M17.0306 12.5307L9.53062 20.0307C9.46093 20.1004 9.37821 20.1556 9.28716 20.1933C9.19612 20.2311 9.09854 20.2505 8.99999 20.2505C8.90144 20.2505 8.80386 20.2311 8.71282 20.1933C8.62177 20.1556 8.53905 20.1004 8.46936 20.0307C8.39968 19.961 8.34441 19.8783 8.30669 19.7872C8.26898 19.6962 8.24957 19.5986 8.24957 19.5001C8.24957 19.4015 8.26898 19.3039 8.30669 19.2129C8.34441 19.1218 8.39968 19.0391 8.46936 18.9694L15.4397 12.0001L8.46936 5.03068C8.32863 4.88995 8.24957 4.69907 8.24957 4.50005C8.24957 4.30103 8.32863 4.11016 8.46936 3.96943C8.61009 3.8287 8.80097 3.74963 8.99999 3.74963C9.19901 3.74963 9.38988 3.8287 9.53062 3.96943L17.0306 11.4694C17.1003 11.5391 17.1557 11.6218 17.1934 11.7128C17.2312 11.8039 17.2506 11.9015 17.2506 12.0001C17.2506 12.0986 17.2312 12.1962 17.1934 12.2873C17.1557 12.3783 17.1003 12.461 17.0306 12.5307Z"
              fill="#3A383F"
            />
          </svg>
        </ButtonIcon>
        <h5>Personal Information</h5>
      </div>

      <div
        className={`${styles.body} ${expended ? styles.body_expended : ""} ${expandAppDetails ? styles.app_details_expanded : ""}`}
      >
        {expended && (
          <>
            <ul>
              <li>
                <div>
                  <p>Name</p>
                  <p>
                    {appData.field_firstname || "-"}{" "}
                    {appData.field_lastname || "-"}
                  </p>
                </div>
              </li>
              <li>
                <div>
                  <p>Personal Phone</p>
                  <p>{appData.field_personalphone ? (formatPhoneNumber(appData.field_personalphone)) : "-"}</p>
                </div>
              </li>

              <li>
                <div>
                  <p>Personal Email</p>
                  <p>{appData.field_email || "-"}</p>
                </div>
              </li>

              <li>
                <div>
                  <p>Personal Street Address</p>
                  <p>{appData.field_personalstreet || "-"}</p>
                </div>
              </li>

              <li>
                <div>
                  <p>DBA City</p>
                  <p>{appData.field_personalcity || "-"}</p>
                </div>
              </li>

              <li>
                <div>
                  <p>DBA State</p>
                  <p>{appData.field_personalstate || "-"}</p>
                </div>
              </li>

              <li>
                <div>
                  <p>DBA Zip</p>
                  <p>{appData.field_personalzip || "-"}</p>
                </div>
              </li>

              <li>
                <div>
                  <p>Period of Residence</p>
                  <p>
                    {appData.field_residenceyears || "-"} year(s){" "}
                    {appData.field_residencemonths || "-"} months
                  </p>
                </div>
              </li>
            </ul>

            {/* Identity Documents */}
            <div>
              <HeadingWithLine text="Identity document" />
              <ul>
                <li>
                  <div>
                    <p>ID Type</p>
                    <p>{getIdType(appData?.field_documenttype) || "-"}</p>
                  </div>
                </li>
                <li>
                  <div>
                    <p>ID Number</p>
                    <p>{appData.field_documentnumber ? formatNumberWithSpaces(appData.field_documentnumber) : "-"}</p>
                  </div>
                </li>
                <li>
                  <div>
                    <p>Social Security Number</p>
                    <p>{appData.field_socialsecurity ? maskNumber(appData.field_socialsecurity) : "-"}</p>
                  </div>
                </li>
                <li>
                  <div>
                    <p>Date of Birth</p>
                    <p>{dateFormatter(appData.field_birthdate)}</p>
                  </div>
                </li>
              </ul>
            </div>

            {/* Ownership */}
            <div>
              <HeadingWithLine text="Ownership" />
              <ul>
                <li>
                  <div>
                    <p>Percentage of ownership</p>
                    <p>{appData.field_ownershippercentage}%</p>
                  </div>
                </li>
              </ul>
            </div>
          </>
        )}

        {expended &&
          appData?.signers?.map((signer, index) => {
            return (
              <div key={index}>
                <h5 className={styles.addl_owner_title}>
                  Additional owner #{index + 2}
                </h5>
                <ul>
                  <li>
                    <div>
                      <p>Name</p>
                      <p>
                        {signer.first_name} {signer.last_name}
                      </p>
                    </div>
                  </li>
                  <li>
                    <div>
                      <p>Personal Phone</p>
                      <p>{signer.phone || "-"}</p>
                    </div>
                  </li>

                  <li>
                    <div>
                      <p>Personal Email</p>
                      <p>{signer.email || "-"}</p>
                    </div>
                  </li>

                  <li>
                    <div>
                      <p>Personal Street Address</p>
                      <p>{signer.address_street || "-"}</p>
                    </div>
                  </li>

                  <li>
                    <div>
                      <p>DBA City</p>
                      <p>{signer.address_city || "-"}</p>
                    </div>
                  </li>

                  <li>
                    <div>
                      <p>DBA State</p>
                      <p>{signer.address_state}</p>
                    </div>
                  </li>

                  <li>
                    <div>
                      <p>DBA Zip</p>
                      <p>{signer.address_zip_code || "-"}</p>
                    </div>
                  </li>

                  <li>
                    <div>
                      <p>Period of Residence</p>
                      <p>
                        {signer.residence_years} year(s){" "}
                        {signer.residence_months} month(s)
                      </p>
                    </div>
                  </li>
                </ul>

                {/* Identity Documents */}
                <div>
                  <HeadingWithLine text="Identity document" />
                  <ul>
                    <li>
                      <div>
                        <p>ID Type</p>
                        <p>{signer.document_type || "-"}</p>
                      </div>
                    </li>
                    <li>
                      <div>
                        <p>ID Number</p>
                        <p>{signer.drivers_license_number || "-"}</p>
                      </div>
                    </li>
                    <li>
                      <div>
                        <p>Social Security Number</p>
                        <p>{signer.social_security}</p>
                      </div>
                    </li>
                    <li>
                      <div>
                        <p>Date of Birth</p>
                        <p>{signer.date_of_birth || "-"}</p>
                      </div>
                    </li>
                  </ul>
                </div>

                {/* Ownership */}
                <div>
                  <HeadingWithLine text="Ownership" />
                  <ul>
                    <li>
                      <div>
                        <p>Percentage of ownership</p>
                        <p>{signer.ownership_percentage}%</p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
}

export default PersonalInformation;
